import { InjectionToken } from '@angular/core';

import { type CurrentOrganizationInfoTabPlugin } from './current-organization-info-tab-plugin';

export const CURRENT_ORGANIZATION_INFO_TAB_PLUGIN = new InjectionToken<CurrentOrganizationInfoTabPlugin[]>(
  'CurrentOrganizationInfoTabPlugin',
);
